/**
 * The URL segment the organization admin panel lives at under the Clarity section:
 * `/clarity/organization` — brain's own `/organization`.
 *
 * Shared for the same reason {@link CLARITY_ADMIN_ROUTE_SEGMENT} is: the panel's route in the
 * composition root, the profile menu's entry into it and the chat's billing link must agree on it,
 * and `type:util` is the one layer all three may reach.
 */
export const CLARITY_ORGANIZATION_ROUTE_SEGMENT = 'organization';
